/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Selected_OnlyInputs */



/**
* | output |
* | --- |
* | "Sync Selected Events Only" |
*
* @param {Offline_Sync_Selected_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_selected_only = /** @type {((inputs?: Offline_Sync_Selected_OnlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Selected_OnlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Synchroniser uniquement les événements sélectionnés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur ausgewählte Ereignisse synchronisieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sincronizza solo eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Синхронизировать только выбранные события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sincronizar solo eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("仅同步已选择事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントのみ同期")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केवल चयनित इवेंट सिंक करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sincronizar apenas eventos selecionados")
	return /** @type {LocalizedString} */ ("Sync Selected Events Only")
});